import { useEffect, useState } from 'react';
import { ResApiDashboardAccountPackage } from '../../types/apiTypes';
import { DashboardAccountPackage } from '../../types/commonTypes';
import { useFetch } from '../useFetch';
import { useOperator } from '../../contexts/OperatorContext';
import { BASE_URL_MAP } from '../../lib/environment';

export const useAccountPackageCounts = () => {
  const [accountPackageCounts, setAccountPackageCounts] = useState<
    DashboardAccountPackage[]
  >([]);
  const { makeRequest, loading, response } = useFetch();
  const operator = useOperator();

  useEffect(() => {
    if (response && !loading)
      setAccountPackageCounts(
        response.map((r: ResApiDashboardAccountPackage) =>
          mapAccountPackageCounts(r)
        )
      );
  }, [response, loading]);

  const getAccountPackageCounts = () => {
    makeRequest(
      `${BASE_URL_MAP['Residential']}/${operator?.id}/BasePackageAccountCounts`,
      'get'
    );
  };

  return { accountPackageCounts, getAccountPackageCounts, loading };
};

const mapAccountPackageCounts = (
  accountPackage: ResApiDashboardAccountPackage
): DashboardAccountPackage => {
  return {
    id: accountPackage.Name,
    value: accountPackage.MediaRoom.Enabled,
    name: accountPackage.Name,
    mf: {
      enabled: accountPackage.MediaFirst.Enabled,
      total: accountPackage.MediaFirst.Total,
    },
    mr: {
      enabled: accountPackage.MediaRoom.Enabled,
      total: accountPackage.MediaRoom.Total,
    },
    mrCounts: `${accountPackage.MediaRoom.Enabled} / ${accountPackage.MediaRoom.Total}`,
    mfCounts: `${accountPackage.MediaFirst.Enabled} / ${accountPackage.MediaFirst.Total}`,
  };
};
